import { cloneElement } from 'react'
import { DeleteButton, SaveButton, Toolbar } from 'react-admin'
import { useLocation } from 'react-router-dom'
import { makeStyles } from 'tss-react/mui'
import { PropsForm, reduceProps } from '~/helpers'

const useToolbarStyles = makeStyles()({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

/**
 * A <TabbedForm> toolbar that can differ per tab.
 *
 * This used to pick the toolbar with react-router 5's `<Route exact path render>`
 * off a `match` prop. react-router 6 removed both, and nothing injects `match`
 * any more, so `match` was always undefined and every tab silently fell back to
 * the default toolbar. The tab index is the trailing path segment
 * (…/boats/42/2), so read it from the location instead.
 */
const TabToolbar = ({ toolbars = [], resource, ...rest }: any) => {
  const props = reduceProps(rest, PropsForm)
  const { classes } = useToolbarStyles()
  const { pathname } = useLocation()

  const tail = pathname.split('/').pop() ?? ''
  const tabIndex = /^\d+$/.test(tail) ? Number(tail) : 0

  const standard = toolbars[0] || (
    <>
      <SaveButton {...props} />
      <DeleteButton {...props} />
    </>
  )
  const forTab = toolbars[tabIndex]

  // A tab with nothing of its own gets no toolbar at all. An empty <Toolbar>
  // is not empty in react-admin 5: it fills itself with Save and Delete, so
  // the history tab of every boat and customer offered to delete the record.
  if (tabIndex > 0 && !forTab) return null

  return (
    <Toolbar {...props} className={classes.toolbar}>
      {tabIndex > 0 ? cloneElement(forTab, props) : standard}
    </Toolbar>
  )
}

export default TabToolbar
